import styled from "styled-components";
import { COLORS } from "../../../../values/colors";
import { Paragraph } from "../../../../lib/Font/styles";
import SubmitButton from "../../../base/Buttons/SubmitButton/SubmitButton";

export const Container = styled.div`
    margin: 0 auto;
    border-radius: 1.5rem;
    margin-top: 3rem; 
    width: 75%;
    background-color: ${COLORS.gray};
    height: auto;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.4);
    margin-bottom: 5rem;
`;

export const DialogContainerHeading = styled.h1`
    color: ${COLORS.white};
    font-size: 2rem;
    font-weight: 600;
    width: 100%;
    margin-left: 2rem;
    margin-bottom: 1rem;
    @media (max-width: 620px) {
        font-size: 1.5rem;
        margin-left: 0rem;
    }
`;

export const CurrentStep = styled.h2`
    color: ${COLORS.inactive};
    font-size: 1.5rem;
    font-weight: 500;
    width: 100%;
    margin-bottom: -1rem;
    margin-left: 2rem;
    @media (max-width: 620px) {
        font-size: 1.2rem;
        margin-left: 0rem;
    }
`;

export const Content = styled(Paragraph)`
    color: ${COLORS.inactive};
    width: 100%;
    margin-left: 2rem;
    margin-bottom: 2rem;
    @media (max-width: 620px) {
        margin-left: 0rem;
    }
`;

export const SeparationLines = styled.hr`
    margin-top: 1.5rem;
    margin-bottom: 2rem;
    border: 0.5px solid ${COLORS.apronBrown};
    width: 100%;
`;

export const CustomSubmitButtonContainer = styled.div`
    width: 100%;
    margin-bottom: 2rem;
    margin-left: 2rem !important; // Force left margin to match other elements
    @media (max-width: 620px) {
        margin-left: 0rem !important;
    }
`;

export const CustomSubmitButton = styled(SubmitButton)`
    width: auto;
    padding: 0.5rem 2rem;
    text-align: center;
`;
